import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { ListadoAlmacenes } from "./components/ListadoAlmacenes";
import { loadConfiguracion } from "../../../../../../redux/modules/configuracion";
import "./styles/InventarioInicial.css";
import { getNombreAcopio } from "../../../../../../utility/utils";

class InventarioInicial extends Component {
    state = {
        regresar: false,
    };

    componentWillMount() {
        // recibir parametro regresar como query param
        const queryParams = new URLSearchParams(this.props.location.search);
        const regresar = queryParams.get("regresar") === "true";
        this.setState({ regresar });
    }

    regresar = () => {
        if(this.state.regresar) {
            this.props.history.goBack();
        }
    };

    render() {
        const { user } = this.props;
        const nombreAcopio = getNombreAcopio(user);

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="inventario_activo"
                    titulo="INVENTARIO INICIAL"
                    subtitulo=""
                    noBorder
                >
                    <ListadoAlmacenes
                        regresar={this.state.regresar ? this.regresar : null}
                        nombreAcopio={nombreAcopio}
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const loader = state.configuracion.loader;
    const user = state.login.me;

    return {
        configuraciones,
        loader,
        user,
    };
};

export default connect(mstp, { loadConfiguracion })(InventarioInicial);
